import { useCallback, useEffect, useRef, useState } from 'react';
import { replaceSubarrayOnIndex } from '../utils/replaceSubarrayOnIndex';
import { useRangesWindowAndConstrain } from '../utils/useRangesWindowAndConstrain';
export const useRangeLoader = (getRowsApiCall, condition, sorting) => {
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const activeRequestsRef = useRef(new Set());
    const { getRange: getConstrainedRangeWindow, reset: resetLoaded } = useRangesWindowAndConstrain();
    const apiCall = useCallback((paging) => getRowsApiCall(condition, sorting, paging).then((data) => ({
        ...data,
        offset: paging.offset,
        pageSize: paging.pageSize,
    })), [condition, getRowsApiCall, sorting]);
    const fetchNextWindow = useCallback((paging) => {
        const requestPromise = apiCall(paging)
            .then((data) => {
            // Only update if this request is still active
            if (activeRequestsRef.current.has(requestPromise)) {
                setRows((rows) => replaceSubarrayOnIndex(rows, data.rows, data.offset));
                setTotalRows(data.total);
                setLastUpdated(data.lastUpdated);
            }
        })
            .catch((e) => {
            // eslint-disable-next-line no-console
            console.error(e);
        })
            .finally(() => {
            activeRequestsRef.current.delete(requestPromise);
            setIsLoading(activeRequestsRef.current.size > 0);
        });
        activeRequestsRef.current.add(requestPromise);
        setIsLoading(true);
        return requestPromise;
    }, [apiCall]);
    const reset = useCallback(() => {
        setRows(() => []);
        setTotalRows(0);
        activeRequestsRef.current.clear(); // Cancel tracking of pending requests
        setIsLoading(false);
        resetLoaded();
    }, [resetLoaded]);
    const softReset = useCallback(() => {
        setIsLoading(false);
        resetLoaded();
    }, [resetLoaded]);
    useEffect(() => reset(), [sorting, condition, reset]);
    const loadRange = useCallback(({ offset, pageSize, maxOffset }) => {
        const paging = getConstrainedRangeWindow(Math.max(0, offset), pageSize, maxOffset);
        paging && fetchNextWindow(paging);
    }, [fetchNextWindow, getConstrainedRangeWindow]);
    return { loadRange, rows, totalRows, lastUpdated, reset, softReset, isLoading };
};
//# sourceMappingURL=useRangeLoader.js.map